import { useContext, useEffect } from 'react'

import { observer } from 'mobx-react-lite'
import styled from 'styled-components'

import { FilterByCategoriesSection } from '../../../../entities/filterByCategories'
import { useGetCategoryCriteria } from '../../../../entities/criteria/queries'
import FilterStorage from '../../../storage/FilterStorage/FilterStorage'
import { FlexColumnStart } from '../../projectComponents'
import { Head } from '../../titles'
import { breakpoints } from '../../breakPoints'
import { FilterTitle } from '../../projectComponents'
import { InputSwitchWithTitle } from '../InputSwitchWithTitle'
import { DynamicCriterionFilters } from './filterComponents/DynamicCriterionFilters'
import { FilterPricePanel } from './filterComponents/FilterPricePanel'

const WrapperColumn = styled(FlexColumnStart)`
  height: 100vh;
  background-color: white;
  position: absolute;
  box-sizing: border-box;
  padding: 20px;
  justify-content: flex-start;
  overflow-y: auto;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
  z-index: 2;

  ${FilterTitle} {
    font-size: 21px;
    line-height: 1.5;
  }
`

const MobileHeading = styled(Head)`
  margin-bottom: 24px;
  @media (width >= ${breakpoints.desktopMin}) {
    display: none;
  }
`

const FilterWindowNew = ({
  categoryId,
  handleFilterModalOpen,
  isSearch,
}: {
  categoryId?: number | null
  handleFilterModalOpen: () => void
  isSearch?: boolean
}) => {
  const filterStore = useContext(FilterStorage)
  const { isHighRatingOnly, isPremiumOnly, setHighRatingOnly, setPremiumOnly, sorting } =
    filterStore
  const criteria = useGetCategoryCriteria(
    { categoryId: categoryId ?? undefined },
    { enabled: Boolean(categoryId) }
  )

  useEffect(() => {
    if (categoryId) filterStore.prepareCriteriaForCategory(categoryId)
  }, [categoryId, filterStore])

  const toggleHightRatingOnly = () => {
    setHighRatingOnly(!(sorting.ratingFrom > 3))
  }
  const togglePremium = () => {
    setPremiumOnly(!sorting.premiumOnly)
  }
  return (
    <WrapperColumn>
      <MobileHeading>Фильтры</MobileHeading>
      <FlexColumnStart style={{ paddingBottom: 32, width: '100%' }}>
        <FlexColumnStart style={{ gap: '32px 0', width: '100%' }}>
          <InputSwitchWithTitle
            sidebar
            subtitle={'Только товары с рейтингом 4 и 5 звезд'}
            switchOn={isHighRatingOnly}
            title={'Высокий рейтинг'}
            toggleSwitch={toggleHightRatingOnly}
          />
          <InputSwitchWithTitle
            sidebar
            subtitle={'От пользователей с премиум-подпиской'}
            switchOn={isPremiumOnly}
            title={'Премиум-товары'}
            toggleSwitch={togglePremium}
          />
          <FilterByCategoriesSection
            handleFilterModalOpen={handleFilterModalOpen}
            isSearch={isSearch}
          />
          <FilterPricePanel title={'Цена за сутки'} />
          {categoryId && criteria.isLoading && <span>Загрузка характеристик…</span>}
          {criteria.isError && <span>Не удалось загрузить характеристики</span>}
          <DynamicCriterionFilters groups={criteria.data?.groupedCriteria ?? []} />
        </FlexColumnStart>
      </FlexColumnStart>
    </WrapperColumn>
  )
}

export default observer(FilterWindowNew)
